<template>
  <div class="order-return-contact-info">
    <h2 class="order-return-container__section-heading">
      {{ t('contactInformationHeading') }}
    </h2>
    <!-- :text="t('productDetailTechincalFacts')" -->
    <div>
      <div class="input-column">
        <validation-observer
          ref="observerAccount"
          tag="form">
          <div class="input-column__container">
            <validation-provider v-slot="{errors}" rules="required" slim>
              <oie-base-input
                v-model="customer.firstName"
                :error-messages="errors"
                :label-text="`${t('orderReturnContactFirstNameLabel')}*`"></oie-base-input>
            </validation-provider>

            <div class="input-column__container">
              <validation-provider v-slot="{errors}" rules="required" slim>
                <oie-base-input
                  v-model="customer.lastName"
                  :error-messages="errors"
                  :label-text="`${t('orderReturnContactLastNameLabel')}*`"></oie-base-input>
              </validation-provider>

              <validation-provider v-slot="{errors}" rules="required" slim>
                <oie-base-input
                  v-model="customer.phone"
                  :error-messages="errors"
                  :label-text="`${t('orderReturnContactPhoneLabel')}*`"></oie-base-input>
              </validation-provider>

              <oie-base-input
                v-model="customer.email"
                :label-text="t('orderReturnContactEmailLabel')"></oie-base-input>
            </div>
          </div>

          <div class="input-column__container save-contact-info">
            <oie-base-checkbox
              v-model="saveContactInfo"
              size="medium"
              is-for="order-return-save-contact-info"
              :text="t('orderReturnSaveContactInfoLabel')"></oie-base-checkbox>
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    orderNumber: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    isOpen: true,
    customer: {
      invoiceAddress: {
        addressLine1: null,
        addressCo: null,
        postalCode: null,
        city: null,
        countryCode: null,
        countryName: null
      },
      customerNumber: 0,
      companyName: null,
      firstName: null,
      lastName: null,
      phone: null,
      email: null
    },
    phoneNumber: null,
    saveContactInfo: false
  }),
  computed: {
  },
  watch: {
    customer: {
      handler: function (newCustomer, oldCustomer) {
        this.publish('order-return-contact-info-updated', newCustomer)

        if (this.saveContactInfo) {
          localStorage.setItem('customerContactInfo', JSON.stringify(newCustomer))
        }
      },
      deep: true
    },
    saveContactInfo(val) {
      if (val) {
        localStorage.setItem('customerContactInfo', JSON.stringify(this.customer))
      } else {
        localStorage.removeItem('customerContactInfo')
      }
    }
  },
  mounted() {
    httpService
      .get(`order-return/contact-info/${this.orderNumber}`, { token: this.token })
      .then(response => {
        this.customer = response.data

        const saved = localStorage.getItem('customerContactInfo')
        if (saved) {
          try {
            this.customer = JSON.parse(saved)
            this.saveContactInfo = true // pre-check the box
          } catch (e) {
            console.error('Failed to parse saved contact info', e)
          }
        }
      })
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen
    }

  }
}
</script>

<style lang="scss">
  .order-return-contact-info {
      margin-top: 3rem;
  }

  .my-pages {
    @include container;
    padding-top: measure(quarter);
    padding-bottom: measure(double);
  }

.my-pages__actions {
  display: flex;
}

.my-pages__page-type-header {
  @include h1-semi-bold;
  margin: 0 measure(half) 0 0;

  @include media(medium) {
    margin: 0;
  }
}

.my-pages__page-description {
  display: none;

  @include media(medium) {
    display: block;
  }
}

.my-pages__actions > * {
  flex-basis: 11.875rem;
  margin-right: measure(quarter);

  &:last-child {
    margin-right: 0;
  }
}

.my-pages__content-grid {
  display: flex;

  @supports (grid-gap: 1rem) {
    display: grid;
    grid-template-columns: 1fr;

    @include media(medium) {
      grid-template-columns: 1fr 1fr;
    }
  }
}

.my-pages__content-grid > * {
  flex-basis: 100%;

  @include media(medium) {
    flex-basis: 50%;

    &:first-child {
      padding-right: measure(half);
    }
  }
}

  .technical-facts {
    margin-bottom: measure(double);
    padding: measure(quarter) 0;
    border-top: 1px solid color(border-gray);
    border-bottom: 1px solid color(border-gray);

    @include media(medium) {
      padding: measure(half) 0;
    }
  }

  .technical-facts__content {
    display: none;
    overflow: hidden;
  }

  .technical-facts__content--is-open {
    display: block;
  }

  .techinical-facts__grid {
    width: 100%;
    padding-top: measure(full);
    padding-bottom: measure(full);
  }

  .technical-facts__table {
    width: 100%;
  }

  .techinical-facts__toggler {
    font-size: 1.5em !important;
  }

  .save-contact-info {
    margin-top: .4rem;
  }

</style>
